<template>
  <div>
    <el-row :gutter="20" type="flex" align="bottom" class="row-user-msg">
      <el-col :span="2">
        <div><i class="el-icon-user-solid"></i></div>
      </el-col>
      <el-col :span="4" class="col-user-msg">
        <p>*{{user.account}}</p>
      </el-col>
      <el-col :span="8" :offset="10" class="col-user-btn-box">
        <el-button type="primary" plain disabled>账号设置</el-button>
        <el-button type="primary" plain @click="resetPwdDialog.visible = true">修改密码</el-button>
        <el-button type="primary" plain @click="logout">退出登录</el-button>
      </el-col>
    </el-row>
    <div class="main">
      <div class="main_center">
        <div class="main_center_left">
          <div class="main_center_left_title">
            <p>我的业务</p>
          </div>
          <el-row :gutter="20">
            <el-col :span="6" v-for="entrance in modelEntrances" :key="entrance.menuId">
              <div class="div-card-box"><embed :src="'/web/' + entrance.link" /></div>
            </el-col>
          </el-row>
        </div>
        <div class="main_center_right">
          <div class="main_center_right_title">
            <div class="main_center_right_title1">系统通知 (-1/10)</div>
            <div>搜索框</div>
            <div class="main_center_right_img">
              <div>图标1</div>
              <div>图标2</div>
            </div>
          </div>
          <div class="main_center_right_center">
            <div class="main_center_right_center_1">
              <div>2021年外籍人才永久居留积分评估申报已开始！</div>
              <div>2021/8/28</div>
              <div>已读</div>
            </div>
            <div class="main_center_right_center_1">
              <div>2021年外籍人才永久居留积分评估申报已开始！</div>
              <div>2021/8/28</div>
              <div>已读</div>
            </div>
            <div class="main_center_right_center_1">
              <div>2021年外籍人才永久居留积分评估申报已开始！</div>
              <div>2021/8/28</div>
              <div>已读</div>
            </div>
            <div class="main_center_right_center_1">
              <div>2021年外籍人才永久居留积分评估申报已开始！</div>
              <div>2021/8/28</div>
              <div>已读</div>
            </div>
            <div class="main_center_right_center_1">
              <div>2021年外籍人才永久居留积分评估申报已开始！</div>
              <div>2021/8/28</div>
              <div>已读</div>
            </div>
            <div class="main_center_right_center_1">
              <div>2021年外籍人才永久居留积分评估申报已开始！</div>
              <div>2021/8/28</div>
              <div>已读</div>
            </div>
            <div class="main_center_right_center_1">
              <div>2021年外籍人才永久居留积分评估申报已开始！</div>
              <div>2021/8/28</div>
              <div>已读</div>
            </div>
            <div class="main_center_right_center_1">
              <div>2021年外籍人才永久居留积分评估申报已开始！</div>
              <div>2021/8/28</div>
              <div>已读</div>
            </div>
            <div class="main_center_right_center_1">
              <div>2021年外籍人才永久居留积分评估申报已开始！</div>
              <div>2021/8/28</div>
              <div>已读</div>
            </div>
            <div class="main_center_right_center_1">
              <div>2021年外籍人才永久居留积分评估申报已开始！</div>
              <div>2021/8/28</div>
              <div>已读</div>
            </div>
            <div class="main_center_right_center_1">
              <div>2021年外籍人才永久居留积分评估申报已开始！</div>
              <div>2021/8/28</div>
              <div>已读</div>
            </div>
            <div class="main_center_right_center_1">
              <div>2021年外籍人才永久居留积分评估申报已开始！</div>
              <div>2021/8/28</div>
              <div>已读</div>
            </div>
            <div class="main_center_right_center_1">
              <div>2021年外籍人才永久居留积分评估申报已开始！</div>
              <div>2021/8/28</div>
              <div>已读</div>
            </div>
            <div class="main_center_right_center_1">
              <div>2021年外籍人才永久居留积分评估申报已开始！</div>
              <div>2021/8/28</div>
              <div>已读</div>
            </div>
            <div class="main_center_right_center_1">
              <div>2021年外籍人才永久居留积分评估申报已开始！</div>
              <div>2021/8/28</div>
              <div>已读</div>
            </div>
            <div class="main_center_right_center_1">
              <div>2021年外籍人才永久居留积分评估申报已开始！</div>
              <div>2021/8/28</div>
              <div>已读</div>
            </div>
            <div class="main_center_right_center_1">
              <div>2021年外籍人才永久居留积分评估申报已开始！</div>
              <div>2021/8/28</div>
              <div>已读</div>
            </div>
            <div class="main_center_right_center_1">
              <div>2021年外籍人才永久居留积分评估申报已开始！</div>
              <div>2021/8/28</div>
              <div>已读</div>
            </div>
            <div class="main_center_right_center_1">
              <div>2021年外籍人才永久居留积分评估申报已开始！</div>
              <div>2021/8/28</div>
              <div>已读</div>
            </div>
            <div class="main_center_right_center_1">
              <div>2021年外籍人才永久居留积分评估申报已开始！</div>
              <div>2021/8/28</div>
              <div>已读</div>
            </div>
            <div class="main_center_right_center_1">
              <div>2021年外籍人才永久居留积分评估申报已开始！</div>
              <div>2021/8/28</div>
              <div>已读</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- -->
    <el-row type="flex" align="middle" class="row-bottom">
      <el-col :span="8">账号注册时间：{{user.gmtCreate}}</el-col>
      <el-col :span="8">上次登录时间：{{user.lastLoginTime}}</el-col>
      <el-col :span="8">登录天数：{{user.countLoginDay}}天</el-col>
      <!--        <el-col :span="8">技术支持电话：-</el-col>-->
    </el-row>
    <!-- 修改密码对话框 -->
    <el-dialog :close-on-click-modal="false" title="修改密码" :visible.sync="resetPwdDialog.visible"
      width="520px">
      <el-form v-if="resetPwdDialog.visible" :model="resetPwdDialog.data" class="form-dialog"
        ref="resetPwdForm" :rules="resetPwdDialog.rules">
        <el-form-item label="旧密码" :label-width="resetPwdDialog.labelWidth" prop="oldPassword">
          <el-input v-model="resetPwdDialog.data.oldPassword" autocomplete="off" type="password">
          </el-input>
        </el-form-item>
        <el-form-item label="新密码" :label-width="resetPwdDialog.labelWidth" prop="newPassword">
          <el-input v-model="resetPwdDialog.data.newPassword" autocomplete="off" type="password">
          </el-input>
        </el-form-item>
        <el-form-item label="确认新密码" :label-width="resetPwdDialog.labelWidth" prop="confirmPassword">
          <el-input v-model="resetPwdDialog.data.confirmPassword" autocomplete="off" type="password"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetPwdDialog.visible = false">取 消</el-button>
        <el-button type="primary" @click="resetPwd">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 补充手机号对话框 -->
    <el-dialog :close-on-click-modal="false" title="补充手机号" :visible.sync="replenishMobile.visible" width="520px">
      <el-form v-if="replenishMobile.visible" :model="replenishMobile.data" class="form-dialog" ref="resetPwdForm" :rules="replenishMobile.rules">
        <el-form-item label="手机号码" :label-width="resetPwdDialog.labelWidth" prop="mobile">
          <el-input v-model="replenishMobile.data.mobile" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div class="remind">请完善注册信息内的手机信息，便于您日后找回账号密码。</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="replenishMobile.visible = false">取 消</el-button>
        <el-button type="primary" @click="replenish">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import tools from '@/utils/tools'
import { Message } from 'element-ui'
export default {
  data () {
    return {
      user: {
        account: '-',
        typeName: '-',
        gmtCreate: '-',
        lastLoginTime: '-',
        countLoginDay: '-'
      },
      modelEntrances: [],
      resetPwdDialog: {
        visible: false,
        labelWidth: '120px',
        data: {
          oldPassword: '',
          newPassword: '',
          confirmPassword: ''
        },
        rules: {
          oldPassword: [
            { required: true, message: '请输入旧密码', trigger: 'blur' }
          ],
          newPassword: [
            { required: true, message: '请输入新密码', trigger: 'blur' },
            { validator: this.validatePass, trigger: ['blur'] }
          ],
          confirmPassword: [
            { required: true, message: '请再次输入新密码', trigger: 'blur' },
            { validator: this.validatePassAgain, trigger: ['blur', 'change'] }
          ]
        }
      },
      replenishMobile: {
        visible: false,
        labelWidth: '120px',
        data: {
          mobile: ''
        },
        rules: {
          confirmPassword: [
            { required: true, message: '输入手机号码', trigger: 'blur' }
          ]
        }
      }
    }
  },
  mounted () {
    this.listModelEntrance()
    this.initUserMsg()
  },
  methods: {
    replenish () {
      this.$http.get(`/ucenter/user/basic/replenishMobile?mobile=${this.replenishMobile.data.mobile}`)
        .then((response) => {
          if (response.status === 200) {
            Message({
              message: '手机号码保存成功！',
              type: 'success'
            })
            this.replenishMobile.visible = false
          }
        })
    },
    initUserMsg () {
      this.user = window.openBjStore.getUser()
      this.user.typeName = tools.userTypeCurrent()
      this.user.gmtCreate = tools.dateFormat(this.user.gmtCreate, 'yyyy-MM-dd hh:mm')
      this.user.lastLoginTime = tools.dateFormat(this.user.lastLoginTime, 'yyyy-MM-dd hh:mm')
    },
    // 程序入口列表
    listModelEntrance () {
      this.$http.get('/ucenter/menu/listUserMenu?parentId=0&iconNull=IS').then(response => {
        this.modelEntrances = response.data
      })
    },
    logout () {
      this.$confirm('确定退出吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/ucenter/user/front/logout').then(() => {
          this.$router.push('/login')
          this.$message.success('退出成功')
        })
      }).catch(() => { })
    },
    resetPwd () {
      const params = this._.merge({}, this.resetPwdDialog.data)
      delete params.confirmPassword
      let validSuccess = true
      this.$refs.resetPwdForm.validate((valid) => {
        if (!valid) {
          validSuccess = false
        }
      })
      // 表单验证不通过
      if (!validSuccess) {
        return
      }
      this.$http.post('/ucenter/user/resetPassword', params).then(response => {
        // Message({
        //   message: response.data.message
        // })
        this.$message.success('修改成功')
        this.resetPwdDialog.visible = false
      })
      // axios.post(`${process.env.VUE_APP_SERVER_URL}/ucenter/user/resetPassword`, params).then((response) => {
      //   Message({
      //     message: response.data.message
      //   })
      //   this.resetPwdDialog.visible = false
      // })
    },
    validatePass (rule, value, callback) {
      if (!/^(?![0-9]+$)(?![^0-9]+$)(?![a-zA-Z]+$)(?![^a-zA-Z]+$)(?![a-zA-Z0-9]+$)[a-zA-Z0-9\S]{12,30}$/.test(value)) {
        callback(new Error('必须是12-30位包含大小写、数字、特殊字符组合'))
        return
      }
      if (!this.resetPwdDialog.data.confirmPassword) {
        callback()
        return
      }
      this.$refs.resetPwdForm.validateField('passwordAgain')
      callback()
    },
    validatePassAgain (rule, value, callback) {
      if (value !== this.resetPwdDialog.data.newPassword) {
        callback(new Error('两次密码不一致'))
        return
      }
      callback()
    }
  },
  watch: {
    'resetPwdDialog.visible': {
      handler (n, o) {
        this.resetPwdDialog.data = {
          oldPassword: null,
          newPassword: null,
          confirmPassword: null
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.row-user-msg {
  margin-top: 20px;
}
.col-user-msg {
  line-height: 2em;
}
.col-user-btn-box {
  text-align: right;
}
.div-card-box {
  text-align: center;
}
.div-card-box embed {
  width: 280px;
  height: 150px;
  margin: 10px auto;
  background: #fff1e9;
  border-radius: 20px;
  box-shadow: 5px 5px 10px #f0f0f0;
  cursor: pointer;
  color: black;
}
.div-card-box embed:hover {
  background: #ff8f50;
  color: white !important;
}
.el-icon-user-solid {
  font-size: 80px;
}
.div-box {
  width: 100%;
  height: 100%;
}
.remind {
  margin-top: 40px;
  font-size: 14px;
  color: #d43c33;
  cursor: pointer;
  text-align: center;
}
.row-bottom {
  background-color: #f2f6fc;
  height: 3em;
}
.row-bottom .el-col {
  padding-left: 1em;
}
.main {
  display: flex;
  flex-direction: column;
  margin-top: 30px;
  .main_center {
    display: flex;
    margin-bottom: 20px;
    .main_center_left {
      flex: 2;
      background: #fff;
      .main_center_left_title {
        display: flex;
        justify-content: center;
        height: 60px;
        margin: 40px 0px 0px 0px;
        border-top: 1px solid #ffdddd;
        p {
          display: inline-block;
          font-weight: bold;
          font-size: 20px;
          background: #ffdbdb;
          color: #c30000;
          border-radius: 30px;
          margin-top: -22px;
          height: 44px;
          line-height: 44px;
          padding: 0px 30px;
        }
      }
      .main_center_left_main {
        min-height: 200px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        overflow: auto;
        width: 777px;
        div {
          height: 150px;
          width: 300px;
          margin-left: 20px;
          margin-right: 20px;
          margin-bottom: 20px;
          margin-top: 20px;
          border: thin solid;
        }
      }
    }
    .main_center_right {
      flex: 1;
      background: #fbfbfb;
      padding: 5px;
      height: 500px;
      display: none;
      /*display: flex;*/
      flex-direction: column;
      .main_center_right_title {
        height: 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        .main_center_right_title1 {
          font-size: 20px;
        }
        .main_center_right_img {
          display: flex;
          div {
            margin-left: 10px;
          }
        }
      }
      .main_center_right_center {
        height: 430px;
        background: #fbfbfb;
        overflow: auto;
        .main_center_right_center_1 {
          height: 50px;
          background: #f2f2f2;
          margin-bottom: 10px;
          border-left: 3px solid #d9001b;
          display: flex;
          align-items: center;
          justify-content: center;
          div:first-of-type {
            flex: 1.4;
            font-size: 15px;
            padding-left: 10px;
          }
          div:nth-of-type(2) {
            flex: 0.6;
            display: flex;
            justify-content: center;
          }
          div:nth-of-type(3) {
            flex: 0.4;
            display: flex;
            justify-content: center;
          }
        }
      }
    }
  }
}
.form-dialog {
  width: 390px;
}
</style>
